import axios from "axios";
import { BASE_URL } from "../../constant/staticUrl";
import axiosInstance from "../../utils/axiosInstance";
const API = axios.create({ baseURL: BASE_URL });



  export const getAllCoursesApi = () =>
    axiosInstance.get(`/admin/course/get-all`);

  


  export const createCourseApi=(formData)=>
    axiosInstance.post("/admin/course/create",formData);
  
  export const deleteCourseApi=(id)=>
    axiosInstance.delete(`/admin/course/delete/${id}`);

  export const updateCourseApi=(id,formData)=>
    axiosInstance.post(`/admin/course/update/${id}`,formData);










  